export default __webpack_public_path__ + "static/media/debate_18.44471432.JPG";